import axios from "axios";
import { API_BASE_URL } from "../environment";

const base = `${API_BASE_URL}/ev-loans`;
const evApi = axios.create();
let refreshRequest = null;

evApi.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

evApi.interceptors.response.use((response) => response, async (error) => {
  const request = error.config;
  const refreshToken = sessionStorage.getItem("refresh_token");
  if (error.response?.status !== 401 || !request || request._evRetried || !refreshToken) {
    return Promise.reject(error);
  }

  request._evRetried = true;
  try {
    if (!refreshRequest) {
      refreshRequest = axios.post(`${API_BASE_URL}/user/refresh-token`, { refresh_token: refreshToken })
        .then((response) => {
          if (!response.data?.status || !response.data?.token) {
            throw new Error("Session refresh did not return a valid access token");
          }
          sessionStorage.setItem("token", response.data.token);
          return response.data.token;
        })
        .finally(() => { refreshRequest = null; });
    }
    const token = await refreshRequest;
    request.headers.Authorization = `Bearer ${token}`;
    return evApi.request(request);
  } catch (refreshError) {
    return Promise.reject(refreshError);
  }
});

export const getEvBranding = () => evApi.get(`${base}/branding`).then((r) => r.data);
export const getEvCustomers = () => evApi.get(`${base}/customers`).then((r) => r.data);
export const getEvCustomer = (id) => evApi.get(`${base}/customers/${id}`).then((r) => r.data);
export const addEvCustomer = (data) => evApi.post(`${base}/customers`, data).then((r) => r.data);
export const updateEvCustomer = (id, data) => evApi.patch(`${base}/customers/${id}`, data).then((r) => r.data);
export const getEvProducts = () => evApi.get(`${base}/products`).then((r) => r.data);
export const addEvProduct = (data) => evApi.post(`${base}/products`, data).then((r) => r.data);
export const updateEvProduct = (id, data) => evApi.patch(`${base}/products/${id}`, data).then((r) => r.data);
export const getEvLoans = () => evApi.get(`${base}/loans`).then((r) => r.data);
export const getEvLoan = (id) => evApi.get(`${base}/loans/${id}`).then((r) => r.data);
export const addEvLoan = (data) => evApi.post(`${base}/loans`, data).then((r) => r.data);
export const updateEvLoan = (id, data) => evApi.patch(`${base}/loans/${id}`, data).then((r) => r.data);
export const updateEvLoanDocuments = (id, data) => evApi.patch(`${base}/loans/${id}/documents`, data).then((r) => r.data);
export const updateEvLoanStatus = (id, data) => evApi.patch(`${base}/loans/${id}/status`, data).then((r) => r.data);
export const recordEvPayment = (id, data) => evApi.post(`${base}/loans/${id}/payments`, data).then((r) => r.data);
